<template>
    <b-modal title="Listino" ref="mdlMagazzinoListini" id="mdlMagazzinoListini" size="lg" @ok="onOk">
        <div class="sa-tab-scroll">
            <div class="sa-flexbox">
                <div class="sa-flexbox-header">
                    <b-row>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">Codice Azienda:</label>
                            <b-form-select v-model="jsonData.codiceAzienda" :options="struttureOptions" value-field="codiceStruttura" text-field="denominazione"></b-form-select>
                        </b-col>

                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">Codice:</label>
                            <b-form-input v-model="jsonData.codice" type="search"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">Tipo:</label>
                            <b-form-select v-model="jsonData.tipo" :options="tipoListiniOptions" value-field="value" text-field="text"></b-form-select>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">Listino Base:</label>
                            <b-form-select v-model="jsonData.idListinoBase" :options="magazzinoListiniOptions" value-field="id" text-field="descrizione"></b-form-select>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">Tipo Calcolo:</label>
                            <b-form-select v-model="jsonData.tipoCalcolo" :options="tipoCalcoloOptions" value-field="value" text-field="text"></b-form-select>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">Valore Rincaro (%):</label>
                            <b-form-input v-model="jsonData.valoreRincaroPercentuale" type="number" step="0.5" min="0.0"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">Prezzo Soccorso:</label>
                            <b-form-input v-model="jsonData.prezzoSoccorso" type="number" step="0.5" min="0.0"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">&nbsp;</label>
                            <b-form-checkbox class="text-success mt-md-2" v-model="jsonData.usaPrezzoBaseSeNullo" switch> Usa prezzo base se nullo </b-form-checkbox>
                        </b-col>

                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" class="mb-3">
                            <label class="sa-label-data">&nbsp;</label>
                            <b-form-checkbox class="mt-md-2" v-model="jsonData.alertPrezzoZero" switch> Alert Prezzo Zero </b-form-checkbox>
                        </b-col>

                        <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-3">
                            <label class="sa-label-data">Descrizione:</label>
                            <b-form-textarea v-model="jsonData.descrizione" rows="3" max-rows="6"></b-form-textarea>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoListiniMixins from "../mixins/MagazzinoListiniMixins";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin, MagazzinoListiniMixins],
    components: {},
    data() {
        return {
            pathResource: "/magazzinolistini",
            pathResourceStrutture: "/strutture",
            jsonData: { codiceAzienda: null, descrizione: null, codice: null, tipo: null, idListinoBase: null, tipoCalcolo: null, valoreRincaroPercentuale: null, prezzoSoccorso: null, usaPrezzoBaseSeNullo: true, alertPrezzoZero: true },
            id: "",
            tipoListiniOptions: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "VENDITA", text: "Vendita" },
                { value: "ACQUISTO", text: "Acquisto" },
            ],
            tipoCalcoloOptions: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "FISSO", text: "Prezzo Fisso (Imposto)" },
                { value: "MARGINE_ULTIMO_ACQ", text: "% su Ultimo Prezzo Acq." },
                { value: "MARGINE_MEDIO_ACQ", text: "% su Prezzo Medio Acq." },
            ],
            struttureOptions: [],
            magazzinoListiniOptions: [],
        };
    },
    methods: {
        show(id = null) {
            let me = this;
            me.jsonData = {
                codiceAzienda: null,
                descrizione: null,
                codice: null,
                tipo: null,
                idListinoBase: null,
                tipoCalcolo: null,
                valoreRincaroPercentuale: null,
                prezzoSoccorso: null,
                usaPrezzoBaseSeNullo: true,
                alertPrezzoZero: true,
            };
            if (id) {
                me.id = id;
                me.loadData();
            }
            me.loadDataStrutture();
            me.loadDataListini();
            me.$refs.mdlMagazzinoListini.show();
        },
        loadDataListini() {
            let me = this;
            me.loadDataResources(me.pathResource, {}, me.resultResponseLoadDataMagazzinoListini);
        },
        resultResponseLoadDataMagazzinoListini(response) {
            this.magazzinoListiniOptions = [];
            this.magazzinoListiniOptions = response.data.data.list.filter((element) => element.id !== this.jsonData.id);
            this.magazzinoListiniOptions.unshift({ id: null, descrizione: "Nessuno" });
        },
        onOk(bvModalEvent) {
            let me = this;
            me.openShowModalLoading();
            me.saveResource(me.pathResource, me.jsonData, me.resultResponseSave);
            bvModalEvent.preventDefault();
            me.closeShowModalLoading();
        },
        resultResponseSave() {
            this.$emit("afterSave");
            this.$refs.mdlMagazzinoListini.hide();
        },
        loadData() {
            this.loadDataResources(this.pathResource + "/" + this.id, {}, this.resulResponseLoadData);
        },
        resulResponseLoadData(response) {
            this.jsonData = response.data.data;
        },
        loadDataStrutture() {
            let me = this;
            me.loadDataResources(me.pathResourceStrutture, {}, me.resultResponseLoadDataStrutture);
        },
        resultResponseLoadDataStrutture(response) {
            let me = this;
            me.struttureOptions = [];
            me.struttureOptions = response.data.data;
            me.struttureOptions.unshift({ codiceStruttura: null, denominazione: "- Seleziona Valore -" });
        },
    },
};
</script>

<style></style>
